import { isEmpty } from "lodash-es";
import {
  EfsMelcoModelsDesignElement,
  ElementListHelper,
} from "melco-shared-logic";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ServiceType } from "../../helper/serviceType";

const { isLettering, isColor, isDesign } = ElementListHelper;

const colorLabel = ({
  code,
  name,
}: {
  code?: string | null;
  name?: string | null;
}) => `${code} ${name}`;

export const useDesignElementTitle = (serviceType: ServiceType) => {
  const { t } = useTranslation();

  return useCallback(
    (
      element: EfsMelcoModelsDesignElement | undefined,
      groupIndex: (element: EfsMelcoModelsDesignElement) => number
    ) => {
      if (!element) {
        // useElementTitle called without an element can happen if the design is replaced and the element that has been selected before does not exist anymore
        return { title: "", subtitle: "" };
      }

      const subtitle = t(`designMappings.service.types.${serviceType}`);

      if (isLettering(element)) {
        return {
          title: t(
            "libraries.designs.detail.form.element_list.lettering_title",
            {
              index: groupIndex(element),
            }
          ),
          subtitle,
        };
      } else if (isColor(element)) {
        return {
          title:
            element.color && !isEmpty(element.color?.name)
              ? colorLabel(element.color) ?? ""
              : element.name ?? "",
          subtitle,
        };
      } else if (isDesign(element)) {
        const { name } = element;

        return {
          title: !isEmpty(name)
            ? name!
            : t("libraries.designs.detail.form.element_list.layer_title", {
                index: groupIndex(element),
              }),
          subtitle,
        };
      } else {
        return { title: "", subtitle: "" };
      }
    },
    []
  );
};
